enum AddressType {
  STANDARD = 'STANDARD',
  DISTANCE = 'DISTANCE',
  PLACE = 'PLACE',
}
export default AddressType;
